import React from 'react';
import { Container, Row } from "react-bootstrap";
import 'animate.css';
import ProjectTabsLatest from './ProjectTabsLatest';
import { useMediaQuery } from 'react-responsive';

const ProjectTabsRelated = ({ mobileProjs, webProjs }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <section className="latest" id="related">
      <div className="latest-text">
        <div className="latest-divider"></div>
        <p>Check other projects</p>
        <div className="latest-divider"></div>
      </div>
      <Container className="project-container">
        <Row className={isMobile ? "project-mobile" : ""}>
          <Row size={12} className="d-flex justify-content-center no-padding">
            {/* <h2>Projects</h2>
              <p>Dive into my game development journey: personal highlights, professional projects I've worked on, and some side quests I've done.</p> */}
            <ProjectTabsLatest latest={isMobile ? mobileProjs : webProjs} />
            {/* {isMobile && <ProjectTabsMobile all={allProjects} prof={professionalProjects} perso={personalProjects} side={sideProjects} />} */}
          </Row>
        </Row>
      </Container>
      {/* <img className="background-image-right" src={colorSharp2}></img> */}
    </section>
  );
};

export default ProjectTabsRelated;
